<h2 mat-dialog-title>{{ 'Associate page' | translate }}</h2>
<mat-dialog-content>
  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Select Page' | translate }}</div>
    <select inactif matNativeControl [(ngModel)]="selectedPage">
      <option *ngFor="let page of possiblePages" [value]="page.id">{{ page.title }}</option>
    </select>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()" [disabled]="!selectedPage">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
